<lab-kpi
  *ngIf="!isAgent"
  [tag]="'_brosh'"
  [filter]="'ALL'"
  [filterType]="'ALL'"
></lab-kpi>

<lab-kpi
  *ngIf="isAgent"
  [tag]="'_brosh'"
  [filter]="agentCode?.toString()"
  [filterType]="'AGENT'"
></lab-kpi>
